var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(-9 -9)"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","stroke":"#000","key":0}),React.createElement("path",{"fill":"#000","fillRule":"nonzero","d":"M22.8 12.6c-.48.24-.96.32-1.52.4.56-.32.96-.8 1.12-1.44-.48.32-1.04.48-1.68.64-.48-.48-1.2-.8-1.92-.8-1.36 0-2.56 1.2-2.56 2.64 0 .24 0 .4.08.56-2.16-.08-4.16-1.12-5.44-2.72-.24.4-.32.8-.32 1.36 0 .88.48 1.68 1.2 2.16-.4 0-.8-.16-1.2-.32 0 1.28.88 2.32 2.08 2.56-.24.08-.48.08-.72.08-.16 0-.32 0-.48-.08a2.592 2.592 0 0 0 2.48 1.84c-.88.72-2 1.12-3.28 1.12H10c1.2.72 2.56 1.2 4 1.2 4.8 0 7.44-4 7.44-7.44v-.32c.56-.4 1.04-.88 1.36-1.44z","key":1})]));
}

Twitter.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Twitter;

Twitter.default = Twitter;
